var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPepperHot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M465.039 134.229C486.504 95.844 484.906 47.059 459.389 10.254C451.848 -0.574 437.078 -3.277 426.186 4.316C415.418 11.895 412.75 26.865 420.289 37.725C434.697 58.48 435.422 85.41 424.387 107.498C407.064 100.117 388.02 96 368 96C331.773 96 299.068 109.834 273.76 131.918L352 165.453V256H442.562L476.088 334.23C498.168 308.924 512 276.223 512 240C512 198.004 493.719 160.551 465.039 134.229ZM320 288V186.553L267.051 163.859C216.203 241.297 188.535 400 56 400C25.125 400 0 425.125 0 456S25.125 512 56 512C236.25 512 376.953 423.729 445.258 343.527L421.461 288H320Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepperHot);
export default __webpack_public_path__ + "static/media/pepper-hot.de3989b630570deaf62b5ecbbfed32fa.svg";
export { ForwardRef as ReactComponent };